import PropTypes from "prop-types";
import { IoClose } from "react-icons/io5";

const ExplanationModal = ({
  isOpen,
  onClose,
  explanation,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4">
      <div
        className="
          flex
          w-full
          max-w-4xl
          max-h-[90vh]
          flex-col
          overflow-hidden
          rounded-3xl
          bg-white
          shadow-2xl
          border
          border-slate-200
        "
      >
        {/* Header */}
        <div
          className="
            relative
            flex-shrink-0
            bg-gradient-to-r
            from-blue-700
            via-indigo-600
            to-purple-700
            px-8
            py-6
            text-white
          "
        >
          <h2 className="text-3xl font-extrabold tracking-wide">
            📖 Question Explanation
          </h2>

          <p className="mt-1 text-sm text-blue-100">
            Read carefully to understand the concept.
          </p>

          <button
            type="button"
            onClick={onClose}
            className="
              absolute
              right-4
              top-4
              flex
              h-11
              w-11
              items-center
              justify-center
              rounded-full
              bg-white
              text-red-600
              shadow-xl
              border
              border-gray-200
              hover:bg-red-50
              hover:scale-110
              transition-all
            "
            aria-label="Close"
          >
            <IoClose size={28} />
          </button>
        </div>


        {/* Explanation Content */}
        <div
          className="
            flex-1
            overflow-y-auto
            bg-gradient-to-b
            from-slate-50
            to-blue-50
            px-8
            py-5
          "
        >
          {explanation ? (
            <div
              className="
                rounded-2xl
                bg-white
                border-l-[8px]
                border-blue-600
                shadow-lg
                p-6
              "
            >
              <div className="flex items-center mb-5">
                <div
                  className="
                    flex
                    h-12
                    w-12
                    items-center
                    justify-center
                    rounded-full
                    bg-blue-100
                    text-2xl
                  "
                >
                  💡
                </div>

                <div className="ml-4">
                  <h3 className="text-2xl font-bold text-slate-800">
                    Study Notes
                  </h3>

                  <p className="text-slate-500">
                    Understand the reasoning behind the answer.
                  </p>
                </div>
              </div>


              <div
                className="
                  rounded-xl
                  border
                  border-blue-100
                  bg-gradient-to-r
                  from-yellow-50
                  to-blue-50
                  p-5
                "
              >
                <p
                  className="
                    whitespace-pre-wrap
                    text-[17px]
                    leading-8
                    tracking-wide
                    text-slate-700
                  "
                >
                  {explanation}
                </p>
              </div>
            </div>
          ) : (
            <div
              className="
                rounded-2xl
                border
                border-yellow-200
                bg-yellow-50
                p-10
                text-center
              "
            >
              <div className="mb-3 text-5xl">
                📚
              </div>

              <h3 className="text-2xl font-bold text-yellow-700">
                No Explanation Available
              </h3>

              <p className="mt-3 text-yellow-600">
                The instructor has not added an explanation for this question.
              </p>
            </div>
          )}
        </div>


        {/* Footer */}
        <div
          className="
            flex-shrink-0
            border-t
            bg-white
            px-8
            py-4
            flex
            justify-end
          "
        >
          <button
            type="button"
            onClick={onClose}
            className="
              rounded-xl
              bg-gradient-to-r
              from-blue-600
              to-indigo-700
              px-8
              py-3
              text-base
              font-semibold
              text-white
              shadow-lg
              hover:shadow-xl
              hover:scale-105
              transition-all
            "
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};


ExplanationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  explanation: PropTypes.string,
};

ExplanationModal.defaultProps = {
  explanation: "",
};

export default ExplanationModal;